var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.712,
    height: 12.158,
    viewBox: "0 0 15.712 12.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7818",
    d: "M97.456 21.592a.864.864 0 0 0 0 .5 8.161 8.161 0 0 0 15.64 0 .875.875 0 0 0 0-.5 8.174 8.174 0 0 0-7.808-5.83 8.18 8.18 0 0 0-7.832 5.832zm5.183-3.513a6.412 6.412 0 0 1 8.638 3.575l.069.184-.068.184a6.417 6.417 0 0 1-12 0l-.068-.184.069-.184a6.368 6.368 0 0 1 3.36-3.575z",
    className: "cls-1",
    transform: "translate(-97.419 -15.76)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    cx: 2.357,
    cy: 2.357,
    r: 2.357,
    className: "cls-1",
    transform: "translate(5.5 3.723)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleIcon);
export default __webpack_public_path__ + "static/media/visible-icon.76cba33e.svg";
export { ForwardRef as ReactComponent };